var map = {
	"./icon-account-dots.svg": 80,
	"./icon-aimbulance.svg": 81,
	"./icon-arrow-right.svg": 82,
	"./icon-assistant-headphones.svg": 83,
	"./icon-basket.svg": 84,
	"./icon-bread-crumbs-arrow.svg": 85,
	"./icon-bus.svg": 86,
	"./icon-calendar.svg": 87,
	"./icon-card.svg": 88,
	"./icon-caret.svg": 89,
	"./icon-cart-block-basket.svg": 90,
	"./icon-cart-block-order.svg": 91,
	"./icon-check.svg": 92,
	"./icon-checkbox.svg": 93,
	"./icon-chevron-down.svg": 94,
	"./icon-chevron-left.svg": 95,
	"./icon-chevron-right.svg": 96,
	"./icon-circle-check.svg": 97,
	"./icon-circle-cross.svg": 98,
	"./icon-circle-plus.svg": 99,
	"./icon-circle-slash.svg": 100,
	"./icon-clock-thin.svg": 101,
	"./icon-clock.svg": 102,
	"./icon-comments.svg": 103,
	"./icon-credit-card.svg": 104,
	"./icon-cross-thin.svg": 105,
	"./icon-cross.svg": 106,
	"./icon-cup.svg": 107,
	"./icon-delete.svg": 108,
	"./icon-disability.svg": 109,
	"./icon-download.svg": 110,
	"./icon-email-hot-line.svg": 111,
	"./icon-exit.svg": 112,
	"./icon-facebook-circle-fora.svg": 113,
	"./icon-facebook-circle.svg": 114,
	"./icon-faq-arrow.svg": 115,
	"./icon-faq-thumb-down.svg": 116,
	"./icon-faq-thumb-up.svg": 117,
	"./icon-faq.svg": 118,
	"./icon-fb.svg": 119,
	"./icon-file.svg": 120,
	"./icon-filter-list.svg": 121,
	"./icon-filter-map.svg": 122,
	"./icon-filters.svg": 123,
	"./icon-for-kids.svg": 124,
	"./icon-instagram-fora.svg": 125,
	"./icon-instagram.svg": 126,
	"./icon-invoice.svg": 127,
	"./icon-kids-trademark.svg": 128,
	"./icon-left-arrow.svg": 129,
	"./icon-lock-closed.svg": 130,
	"./icon-lock-opened.svg": 131,
	"./icon-mail.svg": 132,
	"./icon-marker-2.svg": 133,
	"./icon-marker-outline.svg": 134,
	"./icon-marker.svg": 135,
	"./icon-menu.svg": 136,
	"./icon-money-coins.svg": 137,
	"./icon-more.svg": 138,
	"./icon-note.svg": 139,
	"./icon-pencil.svg": 140,
	"./icon-phone-empty.svg": 141,
	"./icon-phone.svg": 142,
	"./icon-portfolio.svg": 143,
	"./icon-press.svg": 144,
	"./icon-price-cut.svg": 145,
	"./icon-print.svg": 146,
	"./icon-product-placement-no.svg": 147,
	"./icon-product-placement-warning.svg": 148,
	"./icon-product-placement.svg": 149,
	"./icon-proposal-map.svg": 150,
	"./icon-restore.svg": 151,
	"./icon-right-arrow.svg": 152,
	"./icon-search.svg": 153,
	"./icon-select-arrow.svg": 154,
	"./icon-service-bakery.svg": 155,
	"./icon-service-bbq.svg": 156,
	"./icon-service-beer.svg": 157,
	"./icon-service-cleaning-fish.svg": 158,
	"./icon-service-cookery.svg": 159,
	"./icon-service-flower-shop.svg": 160,
	"./icon-service-food-court.svg": 161,
	"./icon-service-fruits.svg": 162,
	"./icon-service-grill.svg": 163,
	"./icon-service-kids-department.svg": 164,
	"./icon-service-kids-pay.svg": 165,
	"./icon-service-order-confectionery.svg": 166,
	"./icon-service-own-coffee.svg": 167,
	"./icon-service-pastry.svg": 168,
	"./icon-service-sushi.svg": 169,
	"./icon-small-calendar.svg": 170,
	"./icon-star.svg": 171,
	"./icon-store-clock.svg": 172,
	"./icon-store-man.svg": 173,
	"./icon-store-marker.svg": 174,
	"./icon-telegram-circle-fora.svg": 175,
	"./icon-telegram-circle.svg": 176,
	"./icon-ticket.svg": 177,
	"./icon-timer-clock.svg": 178,
	"./icon-trash-bucket.svg": 179,
	"./icon-tw.svg": 180,
	"./icon-upload.svg": 181,
	"./icon-user-account.svg": 182,
	"./icon-viber-fora.svg": 183,
	"./icon-viber.svg": 184,
	"./icon-youtube-logo.svg": 185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;